module.exports = __webpack_public_path__ + "static/2-e1fef24dc3fff331a50a6cae7a27e4ac.jpg";